export default "__VITE_ASSET__DSvmxxlE__"